<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-doc"></i>
                            <span>{{$t('survey_results.title')}}</span>
                        </h2>
                    </div>
                    <div class="panel__body">
                        <div v-if="loading">
                            <div class="spinner"></div>
                        </div>
                        <div v-else>
                            <h1>Results:</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';

    import { GET_TRAJECTORY } from '@/store/modules/trajectory';
    import { GET_SURVEY } from '@/store/modules/survey';


    @Component()
    export default class SurveyResults extends Vue {
        name = 'survey-results';

        created() {
            const trajectoryId = +this.$route.params.trajectoryId;
            this.$store.dispatch(GET_TRAJECTORY, { id: trajectoryId })
                .catch(
                    err => {
                        if (err.status === 404) {
                            this.$notify.error(this.$t('notify.trajectory.not_found', { id: trajectoryId }));
                            this.$router.replace({name: 'page_not_found'});
                        }
                    });

            const surveyId = +this.$route.params.surveyId;
            this.$store.dispatch(GET_SURVEY, { trajectoryId, surveyId })
                .catch(
                    err => {
                        if (err.status === 404) {
                            this.$notify.error(this.$t('notify.survey.not_found', { id: surveyId }));
                            this.$router.replace({name: 'page_not_found'});
                        }
                    });
        }

        get loading() {
            return this.$store.state.trajectory.loading || this.$store.state.survey.loading;
        }

        get trajectory() {
            return this.$store.state.trajectory.trajectory;
        }

        get survey() {
            return this.$store.state.survey.survey;
        }

    }
</script>



// WEBPACK FOOTER //
// src/pages/SurveyResults.vue